export default __webpack_public_path__ + "static/experienceImg4-946207dc9cbe884637b9e32796caacbd.webp";